import { Button, Icon } from "@stellar/design-system";

import { DisbursementDetails } from "@/components/DisbursementDetails";

import { SummaryRow } from "./SummaryRow";

import { Disbursement } from "@/types";


interface StepDetailsProps {
  draftDetails?: Disbursement;
  futureBalance: number;
  isStep1Ready: boolean;
  isDraftEnabled: boolean;
  isSavePending: boolean;
  onChange: (updatedState: Disbursement) => void;
  onValidate: (isValid: boolean) => void;
  onNext: () => void;
  onDiscard: () => void;
  onSaveDraft: () => void;
  apiError: string | false;
  onClearError: () => void;
}

export const StepDetails = ({
  draftDetails,
  futureBalance,
  isStep1Ready,
  isSavePending,
  onChange,
  onValidate,
  onNext,
  onDiscard,
  onSaveDraft,
  apiError,
  onClearError,
}: StepDetailsProps) => (
  <form
    onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (!isStep1Ready) return;
      onNext();
    }}
    className="DisbursementForm"
  >
    <SummaryRow
      walletName={draftDetails?.wallet?.name}
      assetCode={draftDetails?.asset?.code}
      registrationContactType={draftDetails?.registrationContactType}
    />

    <DisbursementDetails
      variant="edit"
      details={draftDetails}
      futureBalance={futureBalance}
      onChange={(updatedState: Disbursement) => {
        if (apiError) onClearError();
        onChange(updatedState);
      }}
      onValidate={onValidate}
    />

    <div className="DisbursementButtons">
      <Button
        variant="error"
        size="md"
        icon={<Icon.Trash01 />}
        iconPosition="right"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          onDiscard();
        }}
        disabled={isSavePending}
      >
        Discard
      </Button>
      <div className="DisbursementButtons--continue">
        <Button
          variant="tertiary"
          size="md"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            onSaveDraft();
          }}
          disabled={!isStep1Ready || isSavePending}
          isLoading={isSavePending}
          {...(!isStep1Ready
            ? { title: "Please fill in disbursement name and select required fields" }
            : {})}
        >
          Save draft
        </Button>
        <Button
          variant="primary"
          size="md"
          icon={<Icon.ArrowRight />}
          iconPosition="right"
          type="submit"
          disabled={!isStep1Ready || isSavePending}
        >
          Next
        </Button>
      </div>
    </div>
  </form>
);
